import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { gotoLogin } from "~/utils";
import { startCountdown, stopCountdown } from "~/utils/CountdownTimer";
import { t } from "~/hooks/useI18n";
import { finishAuctionInfoLoading } from "~/pages/areariservata/AuctionInfoLoading";
import { initTablePlus, attachExpandListeners } from '~/tablePlus';

class AtStatoAsta extends Page {

    private auth: any = null;
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private venditoreId: number = Number($("#hdVenditoreId").val()) || 0;
    private IdAsteTelematiche: number = 0;
    private culture: string = (window as any).currenCulture || "it-IT";
    private pollingId: number | null = null;
    private migliorOfferente: number | null = null;
    private miglioreOfferta: number | null = null;
    private astaConclusa: boolean = false;

    // ✅ Aggiungi variabile per tracciare lo stato corrente
    private statoGaraCorrente: number = 0; // 0 = sconosciuto, 1 = da iniziare, 2 = in corso, ecc.

    // ✅ AGGIUNGI QUESTE DUE VARIABILI
    private countdownInitialized: boolean = false;
    private countdownTimerId: number | null = null;

    constructor() {
        super("atstatoastavenditore", "AT Stato Asta Venditore");
    }

    async pageStart(): Promise<void> {
        const that = this;

        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente
        this.IdAsteTelematiche = Number($("#hdIdAsteTelematiche").val());


        let _ = this.spinner.spin();
        try {
            initTablePlus();
            // ✅ 1. Prima chiamata iniziale (tutte e 4 le API)
            await this.InitialLoad();
        } catch (error) {
            console.error("Errore durante il caricamento iniziale:", error);
        } finally {
            this.spinner.stop();
        }

        this.StarPolling();

        return Promise.resolve();
    }

    private async InitialLoad(): Promise<void> {
        console.info("📥 Caricamento iniziale dati asta...");

        try {
            // 1. Prima chiama RefreshDatiAsta per popolare statoGaraCorrente
            await this.RefreshDatiAsta();

            // 2. Poi esegui le altre 3 chiamate in parallelo (più veloce)
            await Promise.all([
                this.RefreshListaOfferteIniziali(),
                this.RefreshListaRilanciOmissis()
            ]);

            console.info(`✅ Caricamento iniziale completato (Stato: ${this.statoGaraCorrente})`);
        } catch (error) {
            console.error("❌ Errore nel caricamento iniziale:", error);
        } finally {
            finishAuctionInfoLoading();
        }
    }


    private StarPolling(): void {
        this.pollingId = window.setInterval(() => {
            //Promise.all([
            //    this.RefreshDatiAsta(),
            //    this.RefreshListaRilanciOmissis(),
            //    this.RefreshListaOfferteIniziali()
            //]).catch(err => console.error("Errore nel polling:", err));
            //console.info("polling....");
            // ✅ Chiama sempre RefreshDatiAsta per aggiornare lo stato
            this.RefreshDatiAsta().then(() => {
                // ✅ Crea un array di promesse condizionali
                const promises: Promise<void>[] = [];

                // ✅ RefreshListaOfferteIniziali solo se stato = 1 (da iniziare)
                if (this.statoGaraCorrente === 1) {
                    promises.push(this.RefreshListaOfferteIniziali());
                }

                // ✅ RefreshListaRilanciOmissis solo se stato = 2 (in corso)
                if (this.statoGaraCorrente == 2) {
                    promises.push(this.RefreshListaRilanciOmissis());
                }

                return Promise.all(promises);
            }).catch(err => console.error("Errore nel polling:", err));

            console.info(`Polling... (Stato: ${this.statoGaraCorrente})`);

        }, 5000);
    }

    private StopPolling(): void {
        if (this.pollingId !== null) {
            clearInterval(this.pollingId);
            this.pollingId = null;
            console.info("STOP polling");
        }

        // ✅ Ferma il countdown se è attivo
        if (this.countdownTimerId !== null) {
            clearInterval(this.countdownTimerId);
            this.countdownTimerId = null;
            this.countdownInitialized = false;
            console.info("STOP countdown");
        }

        // ✅ Ferma anche globalmente (se hai implementato stopCountdown)
        stopCountdown();
    }

    private async RefreshDatiAsta() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/StatoVendita?idAstaTelematica=" + this.IdAsteTelematiche;
            const statoAsta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!statoAsta || statoAsta.length === 0) {
                return;
            }

            await this.PopolaInfoAsta(statoAsta);
        }
    }

    private async RefreshListaRilanciOmissis() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/ListaRilanciOmissis?idAstaTelematica=" + this.IdAsteTelematiche;
            const rilanci = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });


            this.PopolaTabella(rilanci);
        }
    }

    private async RefreshListaOfferteIniziali() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/ListaOfferteIniziali?idAstaTelematica=" + this.IdAsteTelematiche;
            const offerteIniziali = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!offerteIniziali || offerteIniziali.length === 0) {
                return;
            }

            this.PopolaTabellaOfferteIniziali(offerteIniziali);
        }
    }


    private async PopolaInfoAsta(obj: any) {

        //Input nascosti
        $("#ATBestOfferId").val(obj.MigliorOfferente);
        $("#hdRilancioMinimo").val(obj.RialzoMinimo);

        //Dati partial "/AstaTelematica/_InfoTipoAsta 1 o 2"
        $("#data-inizio-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataInizioCauzione));
        $("#ora-inizio-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataInizioCauzione));
        $("#data-fine-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataFineCauzione));
        $("#ora-fine-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataFineCauzione));
        $("#data-inizio-gara").html(UI.formatDateIsoToIt(obj.DataInizio));
        $("#ora-inizio-gara").html(UI.formatTimeIsoToHms(obj.DataInizio));
        $("#data-fine-gara").html(UI.formatDateIsoToIt(obj.DataFine));
        $("#ora-fine-gara").html(UI.formatTimeIsoToHms(obj.DataFine));


        //DATI PARTIAL "/AstaTelematica/_InformazioniGara"
        $("#prezzo-base").html(UI.formatEuroCurrency(obj.PrezzoBase));

        if (obj.PrezzoRiserva > 0) {
            $("#prezzo-riserva").html(UI.formatEuroCurrency(obj.PrezzoRiserva));
        } else {
            $("#li-offerta-minima").addClass("d-none");
        }

        // ✅ Formatta cauzione
        const tipoCauzione = await this.getTipoCauzioneLabel(obj.TipoCauzione);
        $("#tipo-cauzione").html(tipoCauzione);
        if (obj.TipoCauzione == 1) {
            $("#cauzione").html(UI.formatEuroCurrency(obj.Cauzione));
        } else {
            $("#cauzione").html(obj.Cauzione + " " + tipoCauzione);
        }

        if (obj.RialzoMinimo > 0) {
            $("#rialzo-minimo").html(UI.formatEuroCurrency(obj.RialzoMinimo));
            $(".rilancio").removeClass("d-none");
        } else {
            $(".rilancio").addClass("d-none");
        }

        $("#numero-partecipanti").html(obj.NumeroPartecipanti);

        // ✅ Formatta anticipo
        const anticipoValore = obj.Anticipo ?? 0;
        const anticipo = await this.formatTempoAnticipo(anticipoValore);

        // ✅ Formatta prolungamento
        const prolungamentoValore = obj.Prolungamento ?? 0;
        const prolungamento = await this.formatTempoProlungamento(prolungamentoValore);

        // ✅ Estensioni
        const estensioniValore = obj.Estensioni ?? 0;

        // ✅ numero prolungamento
        const prolungamentiAttivati = obj.NumeroProlungamento ?? 0;
        let statoGara: number = obj.Stato;

        // ✅ Controlla se tutti i valori sono 0 per nascondere i prolungamenti
        if (anticipoValore === 0 && prolungamentoValore === 0 && estensioniValore === 0) {
            $(".prolungamenti").addClass("d-none");
            $(".prolungamenti-attivati").addClass("d-none");
        } else {
            $(".prolungamenti").removeClass("d-none");
            if (statoGara == 1 || statoGara == 6) {
                $(".prolungamenti-attivati").addClass("d-none");
            } else {
                $(".prolungamenti-attivati").removeClass("d-none");
            }
        }

        $("#anticipo").html(anticipo);
        $("#prolungamento").html(prolungamento);
        if (estensioniValore === 0) {
            $("#estensioni").html(t("common.illimitati"));
        } else {
            $("#estensioni").html(estensioniValore);
        }
        $("#numero-prolungamento").html(prolungamentiAttivati);

        //DATI PARTIAL "BoxATStatoAsta/_SituazioneCorrente"
        $("#migliore-offerta").html(UI.formatEuroCurrency(obj.PrezzoCorrente));

        //DATI MODALE RILANCIO
        $("#modal-migliore-offerta").html(UI.formatEuroCurrency(obj.PrezzoCorrente));
        $("#modal-prezzo-base").html(UI.formatEuroCurrency(obj.PrezzoBase));
        $("#modal-rialzo-minimo").html(UI.formatEuroCurrency(obj.RialzoMinimo));

        this.migliorOfferente = obj.MigliorOfferente;
        this.miglioreOfferta = obj.PrezzoCorrente;


        //***** Stato gara *****/
        // - 1 da iniziare,
        // - 2 in corso,
        // - 3 conclusa,
        // - 4 aggiudicata,
        // - 5 chiusa,
        // - 6 sospesa

        const today = new Date();
        const inizioasta = new Date(obj.DataInizio);
        const fineasta = new Date(obj.DataFine);



        if (today < inizioasta) {
            statoGara = 1;
        }
        else if (today > fineasta && (statoGara == 1 || statoGara == 2)) {
            statoGara = 3;
            this.astaConclusa = true;
            this.countdownInitialized = false; // ✅ AGGIUNGI
            this.StopPolling();
        } else {

            if (statoGara == 1) {
                //this.CountDown(fineasta, $("#div-count-down")[0] as HTMLDivElement);
                $("#div-count-down").addClass("d-none");

            } else if (statoGara == 2) {
                // ✅ Inizializza countdown SOLO se non è già attivo
                if (!this.countdownInitialized) {
                    this.CountDown(fineasta, $("#div-count-down")[0] as HTMLDivElement);
                    this.countdownInitialized = true;
                }
                $("#div-count-down").removeClass("d-none");
                $("#div-stato-gara").addClass("d-none");
            }
            else {
                $("#div-count-down").addClass("d-none");
                this.astaConclusa = true;
                this.countdownInitialized = false; // ✅ AGGIUNGI
                this.StopPolling();
            }
        }

        // ✅ Salva lo stato corrente
        const statoGaraPrecedente: number = this.statoGaraCorrente;
        this.statoGaraCorrente = statoGara;

        // ✅ Log dettagliato se lo stato è cambiato
        if (statoGaraPrecedente !== statoGara) {
            console.info(`🔄 Stato gara cambiato: ${statoGaraPrecedente} → ${statoGara} (tipo: ${typeof statoGara})`);
        } else {
            console.info(`✅ Stato gara corrente: ${statoGara} (tipo: ${typeof statoGara})`);
        }

        this.aggiornaStatoGara(statoGara);


    }

    private async getTipoCauzioneLabel(tipoCauzioneId: number): Promise<string> {
        let label = "";

        switch (tipoCauzioneId) {
            case 1:
                label = "";
                break;
            case 2:
                label = t("common.percPrezzoOfferto");
                break;
            case 3:
                label = t("common.percPrezzoBase");
                break;
            case 4:
                label = t("common.nessunaCauzione");
                break;
            default:
                label = "";
                break;
        }

        return label;
    }

    private async formatTempoAnticipo(anticipoMin: number): Promise<string> {
        if (anticipoMin <= 0) {
            return "-";
        }

        let value: number;
        let label: string;

        if (anticipoMin >= 1440) {
            // Converti in giorni
            value = Math.floor(anticipoMin / 1440);
            label = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (anticipoMin >= 60) {
            // Converti in ore
            value = Math.floor(anticipoMin / 60);
            label = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            // Mantieni in minuti
            value = anticipoMin;
            label = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${label}`;
    }

    private async formatTempoProlungamento(prolungamentoMin: number): Promise<string> {
        if (prolungamentoMin <= 0) {
            return "-";
        }

        let value: number;
        let label: string;

        if (prolungamentoMin >= 1440) {
            value = Math.floor(prolungamentoMin / 1440);
            label = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (prolungamentoMin >= 60) {
            value = Math.floor(prolungamentoMin / 60);
            label = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            value = prolungamentoMin;
            label = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${label}`;
    }

    private PopolaTabella(obj: any) {
        let tblbody = "";
        const migliorOfferente = this.migliorOfferente;
        const miglioreOfferta = this.miglioreOfferta;
        const userId = this.UserId;

        if (Array.isArray(obj) && obj.length > 0) {
            for (const item of obj) {

                const isMiglioreOfferta = (item.IdAna === migliorOfferente && item.Importo === miglioreOfferta);
                const isRilancioAnnullato = item.Confermata === false;
                let cssTr = "";
                if (isMiglioreOfferta) cssTr = "bestOffer";
                else if (isRilancioAnnullato) cssTr = "cancelledOffer";

                const nomeVisualizzato = (item.IdAna === userId ? item.Nome : item.Alias);

                let badge = "";
                if (isMiglioreOfferta) {
                    badge = `<span class='badge text-bg-success lh-sm'>${t("asta.miglioreOfferta")}</span>`;
                } else if (isRilancioAnnullato) {
                    badge = `<span class='badge text-bg-secondary lh-sm'>${t("asta.rilancioAnnullato")}</span>`;
                }

                tblbody += `
                <tr class="${cssTr}">
                    <th scope="row" class="d-block d-sm-table-cell fw-normal">
                        <div class="d-flex align-items-center">
                            <div role="button" class="btn-expand-row">
                                <div class="arrow arrow--small arrow--down me-2">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div class="d-flex flex-nowrap align-items-center">
                                <span class="whiteSpace-nowrap">${nomeVisualizzato}</span>
                            </div>
                        </div>
                    </th>
                    <td data-label="Importo offerto">
                        <span class="d-flex justify-content-between">
                            ${UI.formatEuroCurrency(item.Importo)} ${badge}
                        </span>
                    </td>
                    <td data-label="Data presentazione offerta" class="col-hide-lg">
                        <span class="whiteSpace-nowrap">${UI.formatDateIsoToIt(item.Data)} ore ${UI.formatTimeIsoToHms(item.Data)}</span>
                    </td>
                </tr>
                <tr class="expand-row-details d-none">
                    <td colspan="3" class="bg-body-secondary px-5 lh-lg small"></td>
                </tr>
            `;
            }
        } else {
            tblbody = `<tr><td colspan="3" class="text-center">${t("asta.nessunaOffertaDisponibile")}</td></tr>
                         <tr class="expand-row-details d-none">
                                <td colspan="3" class="bg-body-secondary px-5 lh-lg small"></td>
                            </tr>
                        `;
        }

        $("#tbl-offerte-at-body").html(tblbody);

        attachExpandListeners();
    }

    private PopolaTabellaOfferteIniziali(obj: any) {
        let tblbody = "";
        const userId = this.UserId;

        if (Array.isArray(obj) && obj.length > 0) {
            for (const item of obj) {
                const nomeVisualizzato = item.Alias;

                tblbody += `
                            <tr>
                                 <th scope="row" class="d-block d-sm-table-cell fw-normal">
                                    <div class="d-flex align-items-center">
                                        <div role="button" class="btn-expand-row">
                                            <div class="arrow arrow--small arrow--down me-2">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <span class="whiteSpace-nowrap">${nomeVisualizzato}</span>
                                        </div>
                                    </div>
                                </th>
                                <td data-label="Importo offerto">${UI.formatEuroCurrency(item.PrezzoOfferto)}</td>
                                <td data-label="Cauzione versata" class="col-hide-sm">
                                    <span class="whiteSpace-nowrap">${UI.formatEuroCurrency(item.ImportoCauzione)}</span>
                                </td>
                                <td data-label="Tempo rogito/consegna" class="col-hide-md">${item.TerminiPagamentoSaldo} ${t("common.giorni")}</td>
                                <td data-label="Data presentazione offerta" class="col-hide-lg">
                                    <span class="whiteSpace-nowrap">${UI.formatDateIsoToIt(item.DataOfferta)} ore ${UI.formatTimeIsoToHms(item.DataOfferta)}</span>
                                </td>
                            </tr>
                            <tr class="expand-row-details d-none">
                                <td colspan="5" class="bg-body-secondary px-5 lh-lg small"></td>
                            </tr>
                        `;
            }

            $("#tbl-offerte-iniziali-body").html(tblbody);
            $("#lista-offerte-iniziali").removeClass("d-none");

            attachExpandListeners();

        } else {
            $("#lista-offerte-iniziali").addClass("d-none");
        }

    }

    private aggiornaStatoGara(stato: number) {
        const el = document.getElementById('stato-gara');
        if (!el) return;
        // Placeholder mentre carica
        el.textContent = '...';
        const key = `lblStatoGaraAT${stato}`;
        el.textContent = t(`asta.${key}`);
    }

    private CountDown(dataOraFine: Date, divCountdown: HTMLDivElement) {
        const now = new Date();
        const diffMs = dataOraFine.getTime() - now.getTime();

        if (diffMs <= 0) {
            console.log("Asta conclusa");
            divCountdown.remove();
            this.countdownInitialized = false; // ✅ Reset flag
            return;
        }

        const days = Math.floor(diffMs / (24 * 60 * 60 * 1000));
        const hours = Math.floor((diffMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
        const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000));
        const seconds = Math.floor((diffMs % (60 * 1000)) / 1000);

        // ✅ Crea struttura HTML con span separati
        const $countdown = $("#countdown");
        if ($countdown.children().length === 0) {
            $countdown.html(`
            <span class="countdown-days">0</span>g: 
            <span class="countdown-hours">0</span>h: 
            <span class="countdown-minutes">0</span>m: 
            <span class="countdown-seconds">0</span>s
        `);
        }

        // ✅ Salva i valori precedenti per confronto
        let prevDays = parseInt($countdown.find(".countdown-days").text()) || 0;
        let prevHours = parseInt($countdown.find(".countdown-hours").text()) || 0;
        let prevMinutes = parseInt($countdown.find(".countdown-minutes").text()) || 0;
        let prevSeconds = parseInt($countdown.find(".countdown-seconds").text()) || 0;

        // ✅ Salva l'ID del timer
        this.countdownTimerId = startCountdown(
            days, hours, minutes, seconds,
            (remainingTime) => {
                // ✅ Aggiorna SOLO se il valore è cambiato
                if (remainingTime.days !== prevDays) {
                    $countdown.find(".countdown-days").text(remainingTime.days);
                    prevDays = remainingTime.days;
                }
                if (remainingTime.hours !== prevHours) {
                    $countdown.find(".countdown-hours").text(remainingTime.hours);
                    prevHours = remainingTime.hours;
                }
                if (remainingTime.minutes !== prevMinutes) {
                    $countdown.find(".countdown-minutes").text(remainingTime.minutes);
                    prevMinutes = remainingTime.minutes;
                }
                if (remainingTime.seconds !== prevSeconds) {
                    $countdown.find(".countdown-seconds").text(remainingTime.seconds);
                    prevSeconds = remainingTime.seconds;
                }
            },
            () => {
                console.log("Asta conclusa");
                divCountdown.remove();
                this.countdownInitialized = false; // ✅ Reset flag
                this.countdownTimerId = null;
            }
        );
    }
}

export default AtStatoAsta;
